var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3616_69845)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3616_69845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.45507 18.9297L7.76062 19.1107C9.04393 19.8723 10.5154 20.2752 12.0159 20.2759H12.0191C16.6272 20.2759 20.3775 16.5264 20.3794 11.918C20.3802 9.68481 19.5114 7.58478 17.9329 6.00508C17.1587 5.22601 16.2377 4.60824 15.2231 4.18753C14.2086 3.76682 13.1207 3.55153 12.0223 3.55411C7.41064 3.55411 3.66023 7.30315 3.65859 11.9113C3.65632 13.4848 4.09943 15.0269 4.93671 16.3592L5.13562 16.6753L4.29088 19.7592L7.45507 18.9297ZM1.87573 22.1484L3.30287 16.9378C2.42272 15.4129 1.95967 13.6829 1.96022 11.9106C1.96254 6.36613 6.47458 1.85547 12.0192 1.85547C14.7098 1.85684 17.2353 2.90391 19.1346 4.80461C21.034 6.70531 22.079 9.23174 22.078 11.9187C22.0756 17.4627 17.5628 21.9742 12.0191 21.9742H12.0147C10.3313 21.9735 8.67727 21.5512 7.20803 20.7501L1.87573 22.1484Z",
    fill: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.77271 22.0429L3.19984 16.8323C2.31817 15.3037 1.85506 13.5697 1.85719 11.8051C1.85952 6.26066 6.37155 1.75 11.9162 1.75C14.6068 1.75137 17.1323 2.79844 19.0316 4.69914C20.9309 6.59984 21.9759 9.12628 21.975 11.8132C21.9725 17.3573 17.4598 21.8688 11.916 21.8688H11.9116C10.2283 21.8681 8.57425 21.4458 7.10501 20.6446L1.77271 22.0429Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9192 3.44924C7.30748 3.44924 3.55707 7.19829 3.55543 11.8064C3.55316 13.38 3.99627 14.922 4.83355 16.2543L5.03246 16.5706L4.18772 19.6545L7.35205 18.8248L7.6576 19.0058C8.94091 19.7674 10.4123 20.1702 11.9129 20.171H11.916C16.5242 20.171 20.2746 16.4215 20.2764 11.8131C20.2798 10.7147 20.0654 9.62655 19.6455 8.61159C19.2255 7.59663 18.6084 6.67505 17.8299 5.90021C17.0557 5.12113 16.1346 4.50335 15.1201 4.08264C14.1055 3.66193 13.0175 3.44664 11.9192 3.44924Z",
    fill: "url(#paint0_linear_3616_69845)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.40194 7.60023C9.21355 7.18176 9.01532 7.17328 8.83636 7.16603L8.35459 7.16016C8.18698 7.16016 7.91465 7.22304 7.68443 7.47459C7.4542 7.72614 6.80469 8.3341 6.80469 9.57066C6.80469 10.8072 7.70534 12.0021 7.83084 12.17C7.95635 12.3378 9.56954 14.9563 12.1243 15.9637C14.2473 16.8009 14.6793 16.6344 15.1403 16.5926C15.6013 16.5507 16.6273 15.9846 16.8366 15.3977C17.0459 14.8108 17.046 14.308 16.9833 14.2029C16.9205 14.0977 16.7529 14.0352 16.5014 13.9095C16.2498 13.7837 15.0144 13.1757 14.784 13.0918C14.5536 13.0079 14.3862 12.9662 14.2184 13.2177C14.0507 13.4693 13.5696 14.0351 13.4229 14.2029C13.2762 14.3706 13.1298 14.3917 12.8782 14.266C12.6267 14.1404 11.8174 13.8749 10.8571 13.0187C10.11 12.3525 9.60564 11.5297 9.45881 11.2783C9.31198 11.0269 9.44322 10.8907 9.56927 10.7655C9.68206 10.6529 9.82055 10.472 9.94646 10.3253C10.0724 10.1786 10.1138 10.0738 10.1975 9.90628C10.2811 9.73881 10.2394 9.59171 10.1765 9.46607C10.1137 9.34043 9.62532 8.09731 9.40194 7.60023Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3616_69845",
    x: -0.124268,
    y: -0.144531,
    width: 24.2024,
    height: 24.293,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_3616_69845"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3616_69845",
    x1: 11.7457,
    y1: 4.45271,
    x2: 11.8304,
    y2: 18.7425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57D163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23B33A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3616_69845"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.9541,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappColor);
export default __webpack_public_path__ + "static/media/whatsapp-color.cdfa67db50471d12ccb70f854e93c5a6.svg";
export { ForwardRef as ReactComponent };